import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './global.css';

import { AuthProvider } from './auth/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AuthProvider>
        <App />
    </AuthProvider>
);
